export type Image = {
  cover: string;
  thumbnail: string;
};

export const START_TIME_VALUE = {
  MORNING: 'morning',
  DAY: 'day',
  EVENING: 'evening',
  NIGHT: 'night',
} as const;

export const COMFORT_VALUE = {
  WILD: 'wild',
  SIMPLE: 'simple',
  STANDARD: 'standard',
  PREMIUM: 'premium',
} as const;

export const ACCOMMODATION_VALUE = {
  HOTEL_3: 'hotel_3',
  HOTEL_4_5: 'hotel_4,hotel_5',
  APARTMENTS: 'apartments',
  GUEST_HOUSE: 'guest_house',
  COTTAGE: 'cottage,villa',
  CAMPING: 'camping',
  GLAMPING: 'glamping',
  HOTEL_2: 'hotel_2,hostel',
  SPA_HOTEL: 'spa_hotel',
  UNIQUE: 'yurt,bungalow,houseboat,camper,boutique_hotel,castle',
  YACHT_SHIP: 'yacht,watership',
  TRAIN: 'train',
  NOT_SET: 'not_set',
} as const;

export const ACCOMMODATION_GROUPS = [
  { key: 'hotel_3', atoms: ['hotel_3'] },
  { key: 'hotel_4_5', atoms: ['hotel_4', 'hotel_5'] },
  { key: 'apartments', atoms: ['apartments'] },
  { key: 'guest_house', atoms: ['guest_house'] },
  { key: 'cottage_villa', atoms: ['cottage', 'villa'] },
  { key: 'camping', atoms: ['camping'] },
  { key: 'glamping', atoms: ['glamping'] },
  { key: 'hotel_2', atoms: ['hotel_2', 'hostel'] },
  { key: 'spa_hotel', atoms: ['spa_hotel'] },
  { key: 'unique', atoms: ['yurt', 'bungalow', 'houseboat', 'camper', 'boutique_hotel', 'castle'] },
  { key: 'yacht_ship', atoms: ['yacht', 'watership'] },
  { key: 'train', atoms: ['train'] },
  { key: 'notSet', atoms: ['not_set'] },
] as const;

export const ACTIVITY_LEVEL_VALUE = {
  MINIMUM: 'minimum',
  EASY: 'easy',
  MEDIUM: 'medium',
  HARD: 'hard',
} as const;

export type StartTimeValue = (typeof START_TIME_VALUE)[keyof typeof START_TIME_VALUE];
export type ComfortValue = (typeof COMFORT_VALUE)[keyof typeof COMFORT_VALUE];
export type AccommodationValue = (typeof ACCOMMODATION_VALUE)[keyof typeof ACCOMMODATION_VALUE];
export type ActivityLevelValue = (typeof ACTIVITY_LEVEL_VALUE)[keyof typeof ACTIVITY_LEVEL_VALUE];
